import { render, staticRenderFns } from "./LineVendorNotes.vue?vue&type=template&id=ed1432aa&"
import script from "./LineVendorNotes.vue?vue&type=script&lang=js&"
export * from "./LineVendorNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports